// API configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Telegram
export const TELEGRAM_BOT_USERNAME = import.meta.env.VITE_TG_BOT_USERNAME || 'xquest_bot';
export const TELEGRAM_BOT_URL = `https://t.me/${TELEGRAM_BOT_USERNAME}`;
export const TELEGRAM_SHARE_TEXTS = [
	'🚀 Join XQuest on Telegram\nTap fast, climb the leaderboard, and qualify for a 100M Xcash airdrop 💰\n🎁 New players get +500 pts on registration!\nPlay early, earn more 👇',
	'💰 100,000,000 Xcash Airdrop\nXQuest is live on Telegram.\nRegister now and get a 🎁 +500 pts bonus instantly.\nPlay, rank up, and receive your share of the Xcash airdrop.',
	'🔥 The 100M Xcash Airdrop is coming\nXQuest TG Game is live.\n🎁 +500 pts bonus for every new registration.\nYour activity determines your allocation — tap more, earn more.',
];

export const getRandomShareText = () => {
	return TELEGRAM_SHARE_TEXTS[Math.floor(Math.random() * TELEGRAM_SHARE_TEXTS.length)];
};

// External links
export const XQUEST_WEB_URL = import.meta.env.VITE_XQUEST_WEB_URL || 'https://xquest.xcash.tech';
export const XQUEST_LEADERBOARD_URL = `${XQUEST_WEB_URL}/leaderboard`;

// Tap game constants (should match backend config)
export const TAP_BATCH_INTERVAL_MS = 500; // Send batch every 500ms
export const TAP_MAX_TPS = 30.0;
export const TAP_SESSION_DURATION_SECONDS = 30;
export const TAP_MAX_SESSIONS_PER_DAY = 3;

// Level thresholds (TPS)
export const TAP_LEVEL2_THRESHOLD = 12;
export const TAP_LEVEL3_THRESHOLD = 15;

// Points per tap at each level
export const POINTS_PER_TAP_LEVEL1 = 1;
export const POINTS_PER_TAP_LEVEL2 = 2;
export const POINTS_PER_TAP_LEVEL3 = 3;

// UI constants
export const COIN_SIZE = 200; // pixels
export const BONUS_ARC_SIZE = 280; // pixels

// Animation durations
export const TAP_ANIMATION_DURATION_MS = 100;
export const FLOAT_UP_DURATION_MS = 600;

// Haptic patterns
export const HAPTIC_TAP = 'light' as const;
export const HAPTIC_LEVEL_UP = 'medium' as const;
export const HAPTIC_SESSION_END = 'heavy' as const;
